export class ReplaceableQueue<T> {
  items: T[];
  newItemHandler: (item: T) => Promise<void>;
  debounceIntervalInMs: number;

  constructor(
    newItemHandler: (item: T) => Promise<void>,
    debounceIntervalInMs: number,
  ) {
    this.items = [];
    this.newItemHandler = newItemHandler;
    this.debounceIntervalInMs = debounceIntervalInMs;
  }

  enqueue<K>(
    item: T,
    keySelector: (item: T) => K,
    shouldReplace: (newItem: T, existingItem: T) => boolean,
  ): void {
    const itemKey = keySelector(item);

    const existingIndex = this.items.findIndex(
      existingItem => keySelector(existingItem) === itemKey,
    );

    if (existingIndex === -1) {
      this.items.push(item);
    } else {
      const existingItem = this.items[existingIndex];
      if (shouldReplace(item, existingItem)) {
        this.items[existingIndex] = item;
      }
    }

    setTimeout(() => {
      this.notify();
    }, this.debounceIntervalInMs);
  }

  notify(): void {
    const item = this.dequeue();
    if (item) {
      this.newItemHandler(item);
    }
  }

  dequeue(): T | undefined {
    return this.items.shift();
  }
}
